import { StyledFilterItem, StyledFilters } from './Filters.style';
import Period from './Period';
import Granularity from './Granularity';
import Team from './Team';
import MetricsInspectionContext from '../../state/context';
import { useContext } from 'react';
import IconWithLabel from './IconWithLabel';
import { ALL_TEAMS } from 'common/constants/teams';

export const multiFilterItems = (filterItem, name) => {
  if (filterItem?.length === 0) {
    return { text: `All ${name}` };
  }

  if (filterItem?.length === 1) {
    return { text: filterItem[0].name };
  } else {
    return {
      text: `${filterItem?.length} ${name}`,
      tooltipText: filterItem?.map(({ name }) => name).join(', ')
    };
  }
};

const Filters = () => {
  const {
    state: {
      filters: { team, repo = [], contributor, service = [], label }
    }
  } = useContext(MetricsInspectionContext);

  return (
    <StyledFilters>
      <StyledFilterItem>
        <Period />
      </StyledFilterItem>
      <StyledFilterItem>
        <Granularity />
      </StyledFilterItem>
      <StyledFilterItem data-testid='team-label'>
        <Team team={team || ALL_TEAMS} />
      </StyledFilterItem>

      {repo?.length > 0 && (
        <StyledFilterItem data-testid='repo-label'>
          <IconWithLabel
            iconName='Repo'
            {...multiFilterItems(repo, 'Repositories')}
          />
        </StyledFilterItem>
      )}
      {contributor && (
        <StyledFilterItem data-testid='contributor-label'>
          <IconWithLabel
            iconName='OutlinedUser'
            text={contributor.name || contributor.email}
          />
        </StyledFilterItem>
      )}
      {service?.length > 0 && (
        <StyledFilterItem data-testid='service-label'>
          <IconWithLabel
            iconName='Service'
            {...multiFilterItems(service, 'Services')}
          />
        </StyledFilterItem>
      )}
      {label && (
        <StyledFilterItem data-testid='label-label'>
          <IconWithLabel iconName='Label' text={label || 'All PR Labels'} />
        </StyledFilterItem>
      )}
    </StyledFilters>
  );
};

export default Filters;
